import ru from './ru/index.ts';

export default { ru };
